import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  invoiceList: { loading: false, data: null, error: null },
  invoiceListById: { loading: false, data: null, error: null },
  createInvoice: { loading: false, data: null, error: null },
  editInvoice: { loading: false, data: null, error: null },
  invoiceFromBills: { loading: false, data: null, error: null },
  editInvoiceStatus: { loading: false, data: null, error: null },
  invoiceStatusToGenerated: { loading: false, data: null, error: null },
  cancelInvoice: { loading: false, data: null, error: null },
  lastInvoiceAndCreditNoteList: { loading: false, data: null, error: null },
  InvoiceAndCreditNoteList: { loading: false, data: null, error: null },
  invoiceListGenerated: { loading: false, data: null, error: null },
  createFinancialInvoice: { loading: false, data: null, error: null },
  getInvoiceNo: { loading: false, data: null, error: null },
  generatePendingEInvoiceList: { loading: false, data: null, error: null },
  rentalSupplementaryInvoiceList: { loading: false, data: null, error: null },
  transportInvoiceList: { loading: false, data: null, error: null },
  deliveryChallanInvoiceList: { loading: false, data: null, error: null },
  finalInvoiceList: { loading: false, data: null, error: null },
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    fetchInvoiceListRequest: (state, action) => {
      state.invoiceList.loading = true;
      state.invoiceList.error = null;
    },
    fetchInvoiceListSuccess: (state, action) => {
      state.invoiceList.data = action.payload;
      state.invoiceList.loading = false;
      state.invoiceList.error = null;
    },
    fetchInvoiceListFailure: (state, action) => {
      state.invoiceList.data = null;
      state.invoiceList.loading = false;
      state.invoiceList.error = action.payload;
    },

    fetchInvoiceListByIdRequest: (state, action) => {
      state.invoiceListById.loading = true;
      state.invoiceListById.error = null;
    },
    fetchInvoiceListByIdSuccess: (state, action) => {
      state.invoiceListById.data = action.payload;
      state.invoiceListById.loading = false;
      state.invoiceListById.error = null;
    },
    fetchInvoiceListByIdFailure: (state, action) => {
      state.invoiceListById.data = null;
      state.invoiceListById.loading = false;
      state.invoiceListById.error = action.payload;
    },

    createInvoiceRequest: (state, action) => {
      state.createInvoice.loading = true;
      state.createInvoice.error = null;
    },
    createInvoiceSuccess: (state, action) => {
      state.createInvoice.data = action.payload;
      state.createInvoice.loading = false;
      state.createInvoice.error = null;
      if (action.payload.category === "Transport") {
        state.transportInvoiceList = addNewInvoiceSuccess(action.payload, {
          ...state.transportInvoiceList,
        });
      } else if (action.payload.category === "Delivery Challan") {
        state.deliveryChallanInvoiceList = addNewInvoiceSuccess(
          action.payload,
          {
            ...state.deliveryChallanInvoiceList,
          }
        );
      } else {
        state.rentalSupplementaryInvoiceList = addNewInvoiceSuccess(
          action.payload,
          {
            ...state.rentalSupplementaryInvoiceList,
          }
        );
      }
    },
    createInvoiceFaliure: (state, action) => {
      state.createInvoice.data = null;
      state.createInvoice.loading = false;
      state.createInvoice.error = action.payload;
    },

    editInvoiceRequest: (state, action) => {
      state.editInvoice.loading = true;
      state.editInvoice.error = null;
    },
    editInvoiceSuccess: (state, action) => {
      state.editInvoice.data = action.payload;
      state.editInvoice.loading = false;
      state.editInvoice.error = null;
      if (action.payload.category === "Transport") {
        state.transportInvoiceList = updateInvoiceListSuccess(action.payload, {
          ...state.transportInvoiceList,
        });
      } else if (action.payload.category === "Delivery Challan") {
        state.deliveryChallanInvoiceList = updateInvoiceListSuccess(
          action.payload,
          {
            ...state.deliveryChallanInvoiceList,
          }
        );
      } else {
        state.rentalSupplementaryInvoiceList = updateInvoiceListSuccess(
          action.payload,
          {
            ...state.rentalSupplementaryInvoiceList,
          }
        );
      }
    },
    editInvoiceFaliure: (state, action) => {
      state.editInvoice.data = null;
      state.editInvoice.loading = false;
      state.editInvoice.error = action.payload;
    },
    createInvoiceFromBillsRequest: (state, action) => {
      state.invoiceFromBills.loading = true;
      state.invoiceFromBills.error = null;
    },
    createInvoiceFromBillsSuccess: (state, action) => {
      state.invoiceFromBills.data = action.payload;
      state.invoiceFromBills.loading = false;
      state.invoiceFromBills.error = null;
    },
    createInvoiceFromBillsFaliure: (state, action) => {
      state.invoiceFromBills.data = null;
      state.invoiceFromBills.loading = false;
      state.invoiceFromBills.error = action.payload;
    },

    editInvoiceStatusRequest: (state, action) => {
      state.editInvoiceStatus.loading = true;
      state.editInvoiceStatus.error = null;
    },
    editInvoiceStatusSuccess: (state, action) => {
      state.editInvoiceStatus.data = action.payload;
      state.editInvoiceStatus.loading = false;
      state.editInvoiceStatus.error = null;
      state.invoiceList = updateInvoiceListSuccess(action.payload, {
        ...state.invoiceList,
      });
    },
    editInvoiceStatusFaliure: (state, action) => {
      state.editInvoice.data = null;
      state.editInvoice.loading = false;
      state.editInvoice.error = action.payload;
    },
    invoiceStatusToGeneratedRequest: (state, action) => {
      state.invoiceListGenerated.loading = true;
      state.invoiceListGenerated.error = null;
    },
    invoiceStatusToGeneratedSuccess: (state, action) => {
      state.invoiceListGenerated.data = action.payload;
      state.invoiceListGenerated.loading = false;
      state.invoiceListGenerated.error = null;
    },
    invoiceStatusToGeneratedFailure: (state, action) => {
      state.invoiceListGenerated.data = null;
      state.invoiceListGenerated.loading = false;
      state.invoiceListGenerated.error = action.payload;
    },
    cancelInvoiceRequest: (state, action) => {
      state.cancelInvoice.loading = true;
      state.cancelInvoice.error = null;
    },
    cancelInvoiceSuccess: (state, action) => {
      state.cancelInvoice.data = action.payload;
      state.cancelInvoice.loading = false;
      state.cancelInvoice.error = null;
    },
    cancelInvoiceFailure: (state, action) => {
      state.cancelInvoice.data = null;
      state.cancelInvoice.loading = false;
      state.cancelInvoice.error = action.payload;
    },
    fetchLastInvoiceAndCreditNoteListRequest: (state, action) => {
      state.lastInvoiceAndCreditNoteList.loading = true;
      state.lastInvoiceAndCreditNoteList.error = null;
    },
    fetchInvoiceAndCreditNoteListRequest: (state, action) => {
      state.InvoiceAndCreditNoteList.loading = true;
      state.InvoiceAndCreditNoteList.error = null;
    },
    fetchLastInvoiceAndCreditNoteListSuccess: (state, action) => {
      state.lastInvoiceAndCreditNoteList.data = action.payload;
      state.lastInvoiceAndCreditNoteList.loading = false;
      state.lastInvoiceAndCreditNoteList.error = null;
    },
    fetchInvoiceAndCreditNoteListSuccess: (state, action) => {
      state.InvoiceAndCreditNoteList.data = action.payload;
      state.InvoiceAndCreditNoteList.loading = false;
      state.InvoiceAndCreditNoteList.error = null;
    },

    fetchLastInvoiceAndCreditNoteListFailure: (state, action) => {
      state.lastInvoiceAndCreditNoteList.data = null;
      state.lastInvoiceAndCreditNoteList.loading = false;
      state.lastInvoiceAndCreditNoteList.error = action.payload;
    },

    fetchInvoiceAndCreditNoteListFailure: (state, action) => {
      state.InvoiceAndCreditNoteList.data = null;
      state.InvoiceAndCreditNoteList.loading = false;
      state.InvoiceAndCreditNoteList.error = action.payload;
    },

    createFinancialInvoiceRequest: (state, action) => {
      state.createFinancialInvoice.loading = true;
      state.createFinancialInvoice.error = null;
    },
    createFinancialInvoiceSuccess: (state, action) => {
      state.createFinancialInvoice.data = action.payload;
      state.createFinancialInvoice.loading = false;
      state.createFinancialInvoice.error = null;
      state.rentalSupplementaryInvoiceList = addNewInvoiceSuccess(
        action.payload,
        {
          ...state.rentalSupplementaryInvoiceList,
        }
      );
    },
    createFinancialInvoiceFaliure: (state, action) => {
      state.createFinancialInvoice.data = null;
      state.createFinancialInvoice.loading = false;
      state.createFinancialInvoice.error = action.payload;
    },
    fetchInvoiceNoRequest: (state, action) => {
      state.getInvoiceNo.loading = true;
      state.getInvoiceNo.error = null;
    },
    fetchInvoiceNoSuccess: (state, action) => {
      state.getInvoiceNo.data = action.payload;
      state.getInvoiceNo.loading = false;
      state.getInvoiceNo.error = null;
    },
    fetchInvoiceNoFailure: (state, action) => {
      state.getInvoiceNo.data = null;
      state.getInvoiceNo.loading = false;
      state.getInvoiceNo.error = action.payload;
    },
    resetInvoice: (data, action) => {
      data.createInvoice.data = null;
      data.createInvoice.error = null;
      data.createInvoice.loading = false;

      data.editInvoice.data = null;
      data.editInvoice.error = null;
      data.editInvoice.loading = false;

      data.invoiceFromBills.data = null;
      data.invoiceFromBills.error = null;
      data.invoiceFromBills.loading = false;

      data.invoiceListGenerated.data = null;
      data.invoiceListGenerated.error = null;
      data.invoiceListGenerated.loading = false;
    },
    fetchGeneratePendingEInvoiceListRequest: (state, action) => {
      state.generatePendingEInvoiceList.loading = true;
      state.generatePendingEInvoiceList.error = null;
    },
    fetchGeneratePendingEInvoiceListSuccess: (state, action) => {
      state.generatePendingEInvoiceList.data = action.payload;
      state.generatePendingEInvoiceList.loading = false;
      state.generatePendingEInvoiceList.error = null;
    },
    fetchGeneratePendingEInvoiceListFailure: (state, action) => {
      state.generatePendingEInvoiceList.data = null;
      state.generatePendingEInvoiceList.loading = false;
      state.generatePendingEInvoiceList.error = action.payload;
    },
    fetchRentalSupplementaryInvoiceListRequest: (state, action) => {
      state.rentalSupplementaryInvoiceList.loading = true;
      state.rentalSupplementaryInvoiceList.error = null;
    },
    fetchRentalSupplementaryInvoiceListSuccess: (state, action) => {
      state.rentalSupplementaryInvoiceList.data = action.payload;
      state.rentalSupplementaryInvoiceList.loading = false;
      state.rentalSupplementaryInvoiceList.error = null;
    },
    fetchRentalSupplementaryInvoiceListFailure: (state, action) => {
      state.rentalSupplementaryInvoiceList.data = null;
      state.rentalSupplementaryInvoiceList.loading = false;
      state.rentalSupplementaryInvoiceList.error = action.payload;
    },
    fetchTransportInvoiceListRequest: (state, action) => {
      state.transportInvoiceList.loading = true;
      state.transportInvoiceList.error = null;
    },
    fetchTransportInvoiceListSuccess: (state, action) => {
      state.transportInvoiceList.data = action.payload;
      state.transportInvoiceList.loading = false;
      state.transportInvoiceList.error = null;
    },
    fetchTransportInvoiceListFailure: (state, action) => {
      state.transportInvoiceList.data = null;
      state.transportInvoiceList.loading = false;
      state.transportInvoiceList.error = action.payload;
    },
    fetchDeliveryChallanInvoiceListRequest: (state, action) => {
      state.deliveryChallanInvoiceList.loading = true;
      state.deliveryChallanInvoiceList.error = null;
    },
    fetchDeliveryChallanInvoiceListSuccess: (state, action) => {
      state.deliveryChallanInvoiceList.data = action.payload;
      state.deliveryChallanInvoiceList.loading = false;
      state.deliveryChallanInvoiceList.error = null;
    },
    fetchDeliveryChallanInvoiceListFailure: (state, action) => {
      state.deliveryChallanInvoiceList.data = null;
      state.deliveryChallanInvoiceList.loading = false;
      state.deliveryChallanInvoiceList.error = action.payload;
    },
    fetchFinalInvoiceListRequest: (state, action) => {
      state.finalInvoiceList.loading = true;
      state.finalInvoiceList.error = null;
    },
    fetchFinalInvoiceListSuccess: (state, action) => {
      state.finalInvoiceList.data = action.payload;
      state.finalInvoiceList.loading = false;
      state.finalInvoiceList.error = null;
    },
    fetchFinalInvoiceListFailure: (state, action) => {
      state.finalInvoiceList.data = null;
      state.finalInvoiceList.loading = false;
      state.finalInvoiceList.error = action.payload;
    },
  },
});

function addNewInvoiceSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}

function updateInvoiceListSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchInvoiceListRequest,
  fetchInvoiceListSuccess,
  fetchInvoiceListFailure,

  fetchInvoiceListByIdRequest,
  fetchInvoiceListByIdSuccess,
  fetchInvoiceListByIdFailure,

  createInvoiceRequest,
  createInvoiceSuccess,
  createInvoiceFaliure,

  editInvoiceRequest,
  editInvoiceSuccess,
  editInvoiceFaliure,

  createInvoiceFromBillsRequest,
  createInvoiceFromBillsSuccess,
  createInvoiceFromBillsFaliure,

  editInvoiceStatusRequest,
  editInvoiceStatusSuccess,
  editInvoiceStatusFaliure,

  invoiceStatusToGeneratedRequest,
  invoiceStatusToGeneratedSuccess,
  invoiceStatusToGeneratedFailure,

  cancelInvoiceRequest,
  cancelInvoiceSuccess,
  cancelInvoiceFailure,

  fetchLastInvoiceAndCreditNoteListRequest,
  fetchInvoiceAndCreditNoteListRequest,
  fetchLastInvoiceAndCreditNoteListSuccess,
  fetchInvoiceAndCreditNoteListSuccess,
  fetchLastInvoiceAndCreditNoteListFailure,
  fetchInvoiceAndCreditNoteListFailure,

  createFinancialInvoiceRequest,
  createFinancialInvoiceSuccess,
  createFinancialInvoiceFaliure,

  fetchInvoiceNoRequest,
  fetchInvoiceNoSuccess,
  fetchInvoiceNoFailure,

  resetInvoice,

  fetchGeneratePendingEInvoiceListRequest,
  fetchGeneratePendingEInvoiceListSuccess,
  fetchGeneratePendingEInvoiceListFailure,

  fetchRentalSupplementaryInvoiceListRequest,
  fetchRentalSupplementaryInvoiceListSuccess,
  fetchRentalSupplementaryInvoiceListFailure,

  fetchTransportInvoiceListRequest,
  fetchTransportInvoiceListSuccess,
  fetchTransportInvoiceListFailure,

  fetchDeliveryChallanInvoiceListRequest,
  fetchDeliveryChallanInvoiceListSuccess,
  fetchDeliveryChallanInvoiceListFailure,

  fetchFinalInvoiceListRequest,
  fetchFinalInvoiceListSuccess,
  fetchFinalInvoiceListFailure,
} = invoiceSlice.actions;

export const getInvoiceSliceListState = (store) => store.invoice?.invoiceList;

export const getInvoiceByIdSliceListState = (store) =>
  store.invoice?.invoiceListById;
export const createInvoiceState = (store) => store.invoice?.createInvoice;
export const editInvoiceState = (store) => store.invoice?.editInvoice;
export const createInvoiceFromBillsState = (store) =>
  store.invoice?.invoiceFromBills;
export const editInvoiceStatusState = (store) =>
  store.invoice?.editInvoiceStatus;
export const cancelInvoiceState = (store) => store.invoice?.cancelInvoice;
export const getLastInvoiceAndCreditNoteListState = (store) =>
  store.invoice?.lastInvoiceAndCreditNoteList;
export const getInvoiceAndCreditNoteListState = (store) =>
  store.invoice?.InvoiceAndCreditNoteList;
export const getInvoiceListGeneratedState = (store) =>
  store.invoice?.invoiceListGenerated;
export const createFinancialInvoiceState = (store) =>
  store.invoice?.createFinancialInvoice;
export const getInvoiceNoState = (store) => store.invoice?.getInvoiceNo;
export const pendingEinvoiceList = (store) =>
  store.invoice?.generatePendingEInvoiceList;
export const getRentalSupplementaryInvoiceListState = (store) =>
  store.invoice?.rentalSupplementaryInvoiceList;
export const getTransportInvoiceListState = (store) =>
  store.invoice?.transportInvoiceList;
export const getDeliveryChallanInvoiceListState = (store) =>
  store.invoice?.deliveryChallanInvoiceList;
export const getFinalInvoiceSliceListState = (store) =>
  store.invoice?.finalInvoiceList;

export default invoiceSlice.reducer;
